import React, { useContext } from "react";
import css from "../Modulecss/Home.module.css";
import { Link } from "react-router-dom";
import { LanguageContext } from "../Components/LanguageContext";

export default function RunningCard({ runnig, winnAmount }) {
  const user = localStorage.getItem("userId");

  const translations = {
    hi: {
      view: "View",
      prize: "Prize",
      entry: "Entry",
      running: "Running",
    },
    en: {
      view: "View",
      entry: "Entry",
      prize: "Prize",
      running: "Running",
    },
  };

  const { language } = useContext(LanguageContext);
  const creatorName = runnig?.Created_by?.Name || "Player";
  const acceptorName = runnig?.Accepetd_By?.Name || "Player";
  const gameAmount = Number(runnig?.Game_Ammount || 0);
  const winAmount =
    typeof winnAmount === "function" ? Number(winnAmount(gameAmount)) : 0;
  const totalPrize = gameAmount + (Number.isFinite(winAmount) ? winAmount : 0);
  const isUserBattle =
    user == runnig?.Accepetd_By?._id || user == runnig?.Created_by?._id;

  const shortName = (name) => {
    return name.length > 7 ? `${name.slice(0, 7)}...` : name;
  };

  return (
    <div className={css.runningBattleCompactCard}>
      <div className={css.runningCompactPlayers}>
        <span className={css.runningCompactStatus}>
          {translations[language].running}
        </span>
        <div className={css.runningCompactNames}>
          <strong>{creatorName}</strong>
          <span>vs</span>
          <strong>{acceptorName}</strong>
        </div>
      </div>

      <div className={css.runningCompactAmounts}>
        <div>
          <span>{translations[language].entry}</span>
          <strong>₹ {gameAmount}</strong>
        </div>
        <div>
          <span>{translations[language].prize}</span>
          <strong>₹ {totalPrize}</strong>
        </div>
      </div>

      {isUserBattle ? (
        <Link
          to={{
            pathname: `/viewgame1/${runnig?._id}`,
            state: {
              prevPath: window.location.pathname,
            },
          }}
          className={css.runningCompactButton}
        >
          {translations[language].view}
        </Link>
      ) : null}
    </div>
  );
}
